import styled, { useTheme } from 'styled-components';
import Column from '../core/components/box/column';
import SizedBox from '../core/components/box/sizedBox';
import { device, useMedia } from '../core/designSystem/device';
import { LXh1, LXh2 } from '../core/texts/lxText';
import ContactForm from './components/contactForm';

const ResponsiveBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1040px;
  @media ${device.tabletAndBelow} {
    flex-direction: column;
  }
`;

interface ContactProps {}
const Contact = (props: ContactProps) => {
  const { isDesktop, isTabletAndBelow } = useMedia();
  const theme = useTheme();

  const Title = () => {
    if (isTabletAndBelow) return <LXh2>{theme.intro.contactUs}</LXh2>;
    else
      return (
        <LXh1
          alignSelf="flex-start"
          overflow="undefined"
          whiteSpace="pre-line"
          textOverflow="clip"
        >
          {theme.intro.contactUs}
        </LXh1>
      );
  };

  return (
    <Column alignItems="center" padding="0 25px">
      <SizedBox height={isDesktop ? 80 : 60} />
      <ResponsiveBox>
        <Title />
        <ContactForm />
      </ResponsiveBox>
    </Column>
  );
};

export default Contact;
